import React from 'react';
import Layout from '../../components/Layout';
import MyProjects from './MyProjects';

const title = 'My Projects — BestHand Large Projects';
const description =
  'Track the large projects you posted on BestHand and compare the quotes verified companies '
  + 'sent — side by side, with identities masked until you accept. Accept a quote to reveal the '
  + 'company and move to an escrow-protected contract.';

async function action({ largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP route is unreachable -> redirect home
  // (additive guard; small-jobs routes untouched). Flag read from the router
  // context (server-only DB read in server.js / SSR-seeded runtime on client);
  // fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <MyProjects />
      </Layout>
    ),
  };
}

export default action;
